import { useUserStore } from "../hooks/useMyUserId";

type SignOutCleanup = (userId: string | null) => void;

const cleanups = new Set<SignOutCleanup>();

/**
 * Registers work to run when the signed-in user signs out, such as dropping
 * data that the next user of this browser must not see.
 *
 * @returns A function that unregisters the cleanup again.
 */
export function registerSignOutCleanup(cleanup: SignOutCleanup): () => void {
  cleanups.add(cleanup);
  return () => {
    cleanups.delete(cleanup);
  };
}

/**
 * Runs every registered sign-out cleanup for the user who is signing out.
 * The auth integrations call this right before the session ends, while the
 * user id is still known.
 */
export function runSignOutCleanups(
  userId: string | null = useUserStore.getState().userId,
): void {
  for (const cleanup of cleanups) {
    try {
      cleanup(userId);
    } catch (error) {
      // One failing cleanup must not keep the others from running.
      console.error("Sign-out cleanup failed", error);
    }
  }
}
